var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
function SvgHelp(props) {
    return (React.createElement("svg", __assign({ viewBox: '0 0 24 24' }, props),
        React.createElement("path", { d: 'M12 .5C5.649.5.5 5.649.5 12S5.649 23.5 12 23.5 23.5 18.351 23.5 12 18.351.5 12 .5zM12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2z' }),
        React.createElement("path", { d: 'M11.792 14.205v-1.43c.962-.017 1.723-.254 2.281-.709.56-.455.839-1.133.839-2.034 0-.832-.26-1.482-.78-1.95-.52-.468-1.213-.702-2.08-.702-.624 0-1.166.115-1.625.345-.46.23-.81.546-1.053.949-.243.403-.36.864-.351 1.384h1.417c0-.433.143-.784.429-1.053.286-.269.663-.403 1.131-.403.442 0 .793.128 1.053.383.26.256.39.61.39 1.06 0 .667-.217 1.124-.65 1.371-.433.248-1.027.371-1.781.371h-.624v2.418h1.404zM11.948 17v-1.638h-1.69V17h1.69z' })));
}
export default SvgHelp;
//# sourceMappingURL=Help.js.map